import Image from 'next/image'
import { NoResultsStateProps } from '@interfaces/header'
import styles from './SearchComponent.module.scss'
import { SEARCH } from '../constants/icons'

const NoResultsState = ({ activeTab, searchQuery, variant }: NoResultsStateProps) => (
  <div className={styles.noResultsContainer}>
    <div className={styles.noResultsContent}>
      <Image src={SEARCH} alt="No results" width={48} height={48} className={styles.noResultsIcon} loading="lazy" />
      <p className={styles.noResultsTitle}>No {activeTab === 'cars' ? 'cars' : 'articles'} found</p>
      <p className={styles.noResultsMessage}>
        We couldn&apos;t find any {activeTab === 'cars' ? 'cars' : 'articles'} matching {searchQuery}. Try searching
        with different keywords.
      </p>
    </div>
  </div>
)

export default NoResultsState
